// extracted by mini-css-extract-plugin
module.exports = {"modal_header":"modal-header_modal_header__tMvQA","border":"modal-header_border__swJKq"};